import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × BALENCIAGA: Brutalist minimalism & cyber rebellion
// Bold sans-serif, black grids, volumetric voids
export function VasarelyBalenciagaMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Pure black background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.black} />

      <g transform="translate(397 540)">
        {/* Brutalist black grid */}
        {Array.from({ length: 18 }).map((_, i) =>
          Array.from({ length: 24 }).map((_, j) => {
            const x = (i - 8.5) * 40;
            const y = (j - 11.5) * 36;
            const void_effect = Math.random() > 0.7;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 18}
                y={y - 16}
                width="36"
                height="32"
                fill={void_effect ? brand.white : brand.black}
                stroke={brand.white}
                strokeWidth="2"
                opacity={void_effect ? 0.9 : 0.3}
              />
            );
          })
        )}

        {/* Volumetric void distortion */}
        {[-1, 1].map((dir) =>
          Array.from({ length: 6 }).map((_, i) => {
            const x = dir * (80 + i * 35);
            const scale = 1 - i * 0.12;
            
            return (
              <rect
                key={`${dir}-${i}`}
                x={x - 40 * scale}
                y={-80 * scale}
                width={80 * scale}
                height={160 * scale}
                fill="none"
                stroke={brand.white}
                strokeWidth="3"
                opacity={0.6 - i * 0.08}
              />
            );
          })
        )}

        {/* Cyber rebellion lines */}
        {Array.from({ length: 32 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 32;
          const glitch = Math.random() > 0.5 ? 20 : 0;
          
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * (240 + glitch)}
              y2={Math.sin(angle) * (240 + glitch)}
              stroke={brand.white}
              strokeWidth="1"
              opacity="0.15"
            />
          );
        })}

        {/* Bold geometric nodes */}
        {[0, 90, 180, 270].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 180;
          
          return (
            <g key={angle}>
              <rect
                x={Math.cos(rad) * r - 25}
                y={Math.sin(rad) * r - 25}
                width="50"
                height="50"
                fill={brand.white}
                opacity="0.8"
              />
              <rect
                x={Math.cos(rad) * r - 20}
                y={Math.sin(rad) * r - 20}
                width="40"
                height="40"
                fill={brand.black}
              />
            </g>
          );
        })}

        {/* Minimalist accent circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 60 + i * 20;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={brand.white}
              strokeWidth="1"
              opacity={0.25 - i * 0.02}
            />
          );
        })}

        {/* Central void */}
        <rect x="-60" y="-60" width="120" height="120" fill={brand.white} opacity="0.9" />
        <rect x="-50" y="-50" width="100" height="100" fill={brand.black} />
        <rect x="-50" y="-50" width="100" height="100" fill="none" stroke={brand.white} strokeWidth="4" />
      </g>

      {/* Balenciaga text */}
      <text x="397" y="1030" textAnchor="middle" fontFamily="sans-serif" fontWeight="900" fontSize="14" fill={brand.white} letterSpacing="4">
        MINIMALISM BRUTALIST
      </text>
    </g>
  );
}
